import {
  ResourceLinkType,
  UserMeClipType,
} from '../../core/entities/clip/constants';

export function getResourceLinkType(
  clipType: UserMeClipType,
): ResourceLinkType {
  const clipTypeToResourceLinkType: Record<UserMeClipType, ResourceLinkType> = {
    [UserMeClipType.COLUMN]: ResourceLinkType.COLUMN,
    [UserMeClipType.COMPANY_COLUMN]: ResourceLinkType.COLUMN,
    [UserMeClipType.ENTRY_SHEET]: ResourceLinkType.ENTRY_SHEET,
    [UserMeClipType.SELECTION_REPORT]: ResourceLinkType.SELECTION_REPORT,
  };

  return clipTypeToResourceLinkType[clipType];
}
